import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import { blueGrey } from '@mui/material/colors';

const tableCell = {
	color: blueGrey[50],
	paddingLeft: 4,
	border: 'none',
	'& .MuiCheckbox-root.Mui-checked': {
		color: blueGrey[50],
	},
	'& .MuiTableSortLabel-root.MuiSvdIcon-root': {
		color: blueGrey[50],
	},
	'& .MuiTableSortLabel-icon ': {
		opacity: 0.5,
		color: 'blueGrey[50]',
	},
	'& .MuiButtonBase-root.MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon':
		{
			opacity: 1,
			color: blueGrey[50],
		},
};

export default function SalesTableHeader({
	cells,
	handleSorting,
	salesTableSettings,
}) {
	return (
		<TableHead
			sx={{
				position: 'sticky',
				top: 0,
				zIndex: 10,
				backgroundColor: blueGrey[800],
				color: blueGrey[50],
				marginBottom: 16,
				border: 'none',
			}}
		>
			<TableRow>
				<TableCell sx={{ minWidth: 60, border: 'none' }}></TableCell>
				{cells.map((cell) => (
					<TableCell
						key={cell.id}
						align={cell.align}
						padding={cell.disablePadding ? 'none' : 'normal'}
						sortDirection={
							salesTableSettings.sortBy === cell.id
								? salesTableSettings.sortOrder
								: false
						}
						sx={tableCell}
					>
						{cell.label}
						{cell.sortable && (
							<TableSortLabel
								active={salesTableSettings.sortBy === cell.id}
								direction={
									salesTableSettings.sortBy === cell.id
										? salesTableSettings.sortOrder
										: 'asc'
								}
								onClick={() => handleSorting(cell.id)}
								sx={tableCell}
							/>
						)}
					</TableCell>
				))}
			</TableRow>
		</TableHead>
	);
}

SalesTableHeader.propTypes = {
	cells: PropTypes.array.isRequired,
	handleSorting: PropTypes.func.isRequired,
	salesTableSettings: PropTypes.object.isRequired,
};
